import { IPayerBalance } from "../interface/ICurrentBalance";

export interface IPayerBalanceResponse {
    totalAmount: number;
    overdueDate: string;
}

export const getResponseToState = (response: IPayerBalanceResponse[]): IPayerBalance => ({
    amount: response[0].totalAmount,
    paymentDate: response[0].overdueDate,
});
